module.exports = __webpack_public_path__ + "static/img/result_ceil_lx.1c24fc3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/parts/result/result_ceil_lx.jpg
// module id = ZsCF
// module chunks = 3